import { MagnifyingGlassIcon } from '@heroicons/react/20/solid'
import classNames from 'classnames'
import { debounce } from 'lodash'
import { ReactElement } from 'react'
import { formatPhoneNumber } from 'app/formatPhoneNumber'
import { sanitizeValue } from 'app/utils'

const formatValue = (_value: string): string => {
  if (_value && /^\d+$/.test(_value) && _value.length === 10) {
    return formatPhoneNumber(_value) ?? ``
  }
  return /^\d+$/.test(_value) ? _value.replace(/(|)|-|\s/, ``) : (_value ?? ``)
}

export function InputSearch({
  value,
  placeholder,
  className,
  textSize,
  disabled,
  onSearch,
}: {
  value?: string | number | readonly string[] | undefined
  placeholder?: string | undefined | null
  className?: string
  textSize?: string
  disabled?: boolean
  onSearch: (text: string) => void
}): ReactElement {
  const handleTextValue = (text: string) => {
    let value = sanitizeValue(text) as string
    onSearch(/^\d+$/.test(value) ? value.replace(/(|)|-|\s/, ``) : (value ?? ``))
  }
  return (
    <div
      className={classNames(`inline-flex items-center gap-x-1 rounded-md`, className ?? `h-8 px-2`, {
        'bg-surface-muted': disabled,
      })}
    >
      <MagnifyingGlassIcon className={classNames(`relative h-4 w-4`, { 'cursor-not-allowed text-subtle': disabled })} />
      <input
        type="text"
        defaultValue={value ?? ``}
        disabled={disabled}
        className={classNames(
          `h-6 w-full border-none p-0 text-strong outline-none placeholder:text-minimal focus:border-x-0 focus:border-t-0 focus:border-default disabled:cursor-not-allowed disabled:bg-surface-muted disabled:placeholder:text-minimal`,
          textSize ?? `text-body-xs`,
        )}
        placeholder={placeholder ?? `Search`}
        onChange={debounce((evt) => {
          let value = evt.target.value.trim()
          handleTextValue(value)
          evt.target.value = formatValue(value)
        }, 250)}
        autoFocus
      />
    </div>
  )
}
